import { useState, useEffect } from 'react';
import { insertContent } from 'hubspot-prosemirror/prosemirror/utils/documentUtils';
// @ts-expect-error module not typed
import { useThreadHistory } from 'conversations-thread-view/thread-histories/hooks/useThreadHistory';
import { ReplyRecommendation } from './ReplyRecommendation';
import { getReplyRecommendationsHistory, getCurrentReplyRecommendation, getLastConversationalMessage } from 'conversations-message-history/reply-recommendations/operators/getters';
import { replyRecEdited, replyRecSeen, replyRecSent } from '../events/ReplyRecommendationEvents';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error module not typed
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ReplyRecommendationManager = ({
  editorState,
  onSubmit,
  setEditorState,
  threadId,
  shouldDisableSubmit,
  disableSubmitMessage
}) => {
  const [replyRecOpen, setReplyRecOpen] = useState(false);
  const {
    asyncThreadHistory
  } = useThreadHistory({
    threadId
  });
  const threadHistory = getData(asyncThreadHistory);
  const replyRecommendationsHistory = getReplyRecommendationsHistory(threadHistory);
  const lastConversationalMessage = getLastConversationalMessage(threadHistory);
  const lastConversationalMessageId = getId(lastConversationalMessage);
  const recBody = getCurrentReplyRecommendation({
    replyRecommendationsHistory,
    lastConversationalMessage
  });
  const currentReplyRecInResponseTo = replyRecommendationsHistory[lastConversationalMessageId] ? lastConversationalMessageId : '';
  const onReplyRecEdit = () => {
    trackEvent(replyRecEdited(currentReplyRecInResponseTo));
    setEditorState(insertContent({
      htmlBody: recBody,
      editorState,
      from: editorState.doc.content.size <= 2 ? 0 : editorState.doc.content.size,
      to: editorState.doc.content.size
    }));
    setReplyRecOpen(false);
  };
  const onReplyRecSend = () => {
    trackEvent(replyRecSent(currentReplyRecInResponseTo));
    onSubmit({
      html: recBody,
      plainText: recBody
    });
    setReplyRecOpen(false);
  };
  const onReplyRecIgnore = () => {
    setReplyRecOpen(false);
  };
  useEffect(() => {
    if (recBody) {
      setReplyRecOpen(true);
    }
  }, [recBody]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: replyRecOpen && recBody && /*#__PURE__*/_jsx(ReplyRecommendation, {
      onEdit: onReplyRecEdit,
      onSend: onReplyRecSend,
      onIgnore: onReplyRecIgnore,
      recBody: recBody,
      shouldDisableSubmit: shouldDisableSubmit,
      disableSubmitMessage: disableSubmitMessage,
      track: () => trackEvent(replyRecSeen(currentReplyRecInResponseTo))
    })
  });
};
ReplyRecommendationManager.displayName = 'ReplyRecommendationManager';